<template>
  <div class="login_reginster reginster">
    <!-- <div class="login_info">
			<div class="login_text1">{{ $t('login.name') }}</div>
			<div class="login_text2">{{ $t('login.page') }}</div>
		</div> -->

    <v-switchLang ref="switchLang" />
    <v-footer class="footer-icp" />
    <v-chooseCountry
      v-if="ruleFormCountry.countryValue && !isPhoneLogin "
      :country="ruleFormCountry.countryValue"
      class="opple-country"
      @changeCountryValue="changeCountryValue"
    />

    <img
      class="login_logo"
      :src="require('@static/login/login_logo.png')"
    >
    <div
      v-if="!isCountryTab"
      class="login_cont"
      :style="$store.state.lang !== 'zh-cn' && $store.state.lang !== 'en-us'?'width:450px !important;':''"
    >
      <div
        style=""
        class="login_tab"
        :class="[isCountryTab?'login_tab hidden':'login_tab ']"
      >
        <div class="login_tab_div textlink top">
          <span
            :class="isPhoneLogin && $store.state.hiddenPhone ? 'login_span left login_span_flow title' : 'login_span left login_span_flow title login_curr'"
            :style="$store.state.lang !== 'zh-cn'?'font-size:16px !important;':''"
            @click="login"
          >{{ isLogin ? $t("login.text") : $t("login.text2") }}</span>
          <template
            v-if="
              !$store.state.isLocalServer && 
                ($store.state.bowerHostname !== $store.state.IP1) && 
                $store.state.hiddenPhone && 
                !$store.state.isIot3"
          >
            <span
              class="line"
            >|</span>
            <span
              class="login_span right login_span_flow title"
              :class="!isPhoneLogin ? '' : 'login_curr'"
              :style="$store.state.lang !== 'zh-cn'?'font-size:16px !important;':''"

              @click="login_phone"
            >{{ $t("login.phone") }}</span>
          </template>
        </div>
        <div
          v-show="isLogin && !isPhoneLogin"
          class="login_tab_cont"
        >
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="ru1"
            label-width="45px"
            class="demo-ruleForm"
          >
            <el-form-item
              prop="name"
              class="login_line line_bg1"
            >
              <em>*</em>
              <el-input
                v-model="ruleForm.name"
                :placeholder="$t('login.placeholdername')"
                @blur="handleBlurName(ruleForm.name)"
              />
              <el-input
                style="display: none"
                type="text"
                name="fakeusernameremembered"
              />
            </el-form-item>
            <el-form-item
              prop="eyetxt1"
              class="login_line line_bg2"
            >
              <em>*</em>
              <el-input
                style="display: none"
                type="password"
                name="fakepasswordremembered"
              />
              <el-input
                v-if="pwdType1"
                v-model="ruleForm.eyetxt1"
                type="text"
                :placeholder="$t('login.placeholderpsw')"
                @keyup.enter.native="submitForm('ruleForm')"
              />
              <el-input
                v-else
                v-model="ruleForm.eyetxt1"
                type="password"
                autocomplete="new-password"
                :placeholder="$t('login.placeholderpsw')"
                @keyup.enter.native="submitForm('ruleForm')"
              />
              <img
                :src="seen1 ? unseenImg : seenImg"
                class="eye"
                @click="changeType1()"
              >
            </el-form-item>
            <!-- <el-form-item
                prop="countryValue"
                class="login_line line_country"
              >
                <em>*</em>
                <el-select
                  v-model="ruleForm.countryValue"
                  filterable
                  :placeholder="$t('projectmsg.plhode2')"
                  style="
                    position: absolute !important;
                    right: 0;
                    left: 0;
                    display: contents;
                  "
                >
                  <el-option
                    v-for="item in $store.state.baseData.CountryList"
                    :key="item.CountryCode"
                    :label="item.CountryName"
                    :value="item.CountryCode"
                  />
                </el-select>
              </el-form-item> -->
          </el-form>
          <!-- <div class="login_tab_div textlink">
            <template v-if="$store.state.isLocalServer == false">
              <span class="login_span left" @click="login">{{
                $t("login.text2")
              }}</span>
            </template>
            <span class="login_span right" @click="goregister">{{
              $t("login.register")
            }}</span>
          </div> -->
        </div>
        <template v-if="$store.state.isLocalServer == false && !isPhoneLogin">
          <div
            v-show="!isLogin"
            class="login_tab_cont"
          >
            <template>
              <el-form
                ref="ruleForm2"
                :model="ruleForm2"
                :rules="ru2"
                label-width="45px"
                class="demo-ruleForm"
              >
                <el-form-item
                  prop="name"
                  class="login_line line_bg1"
                >
                  <em>*</em>
                  <el-input
                    v-model="ruleForm2.name"
                    :placeholder="$t('login.email')"
                    @blur="handleBlurName(ruleForm2.name)"
                  />
                </el-form-item>
                <el-form-item
                  prop="email"
                  class="login_line line_bg5 line_bg5"
                >
                  <em>*</em>
                  <el-input
                    v-model="ruleForm2.email"
                    type="text"
                    :placeholder="$t('register.yanzhneg')"
                    @keyup.enter.native="submitForm('ruleForm2')"
                  />
                  <el-button
                    v-if="Verification"
                    class="yanz"
                    :loading="issending"
                    type="text"
                    @click="SendLoginVerifyCode('ruleForm2')"
                  >
                    {{ $t("login.getCode") }}
                  </el-button>
                  <el-button
                    v-else
                    class="yanz"
                    type="text"
                  >
                    {{ (timer > 10 ? timer : "0" + timer) + "s" }}
                  </el-button>
                </el-form-item>
                <!-- <el-form-item
                  prop="countryValue"
                  class="login_line line_country"
                >
                  <em>*</em>
                  <el-select
                    v-model="ruleForm2.countryValue"
                    filterable
                    :placeholder="$t('projectmsg.plhode2')"
                    style="
                      position: absolute !important;
                      right: 0;
                      left: 0;
                      display: contents;
                    "
                  >
                    <el-option
                      v-for="item in $store.state.baseData.CountryList"
                      :key="item.CountryCode"
                      :label="item.CountryName"
                      :value="item.CountryCode"
                    />
                  </el-select>
                </el-form-item> -->
              </el-form>
            </template>
          </div>
          <!-- <div class="go_button textlink">
						<span class="go_register" @click="goregister">{{ $t('login.register') }}</span>
						<span class="go_psw" @click="gopasswords">{{ $t('login.passwords') }}</span>
					</div> -->
        </template>

        <div
          v-if="isPhoneLogin"
          class="login_tab_cont"
        >
          <template>
            <el-form
              ref="ruleForm3"
              :model="ruleForm3"
              :rules="rules3"
              label-width="45px"
              class="demo-ruleForm"
            >
              <el-form-item
                prop="name"
                class="login_line line_bg8"
              >
                <em>*</em>
                <el-input
                  v-model="ruleForm3.name"
                  :placeholder="$t('login.phoneplace')"
                />
              </el-form-item>
              <el-form-item
                prop="email"
                class="login_line line_bg5 line_bg5 login_tele"
              >
                <em>*</em>
                <el-input
                  v-model="ruleForm3.email"
                  type="text"
                  :placeholder="$t('login.phoneverify')"
                  @keyup.enter.native="submitForm('ruleForm3')"
                />
                <div class="login_ali-vali-codeBtn">
                  <OppleAliValiCodeBtn :tele="ruleForm3.name" cache-key="LOGIN_CODE_TIMER" />
                </div>
                
                <!-- <el-button
                  v-if="Verification"
                  class="yanz"
                  :loading="issending"
                  type="text"
                  @click="getAliCodeVal"
                >
                  {{ $t("login.getCode") }}
                </el-button>
                <el-button
                  v-else
                  class="yanz"
                  type="text"
                >
                  {{ (timer > 10 ? timer : "0" + timer) + "s" }}
                </el-button> -->
              </el-form-item>
            </el-form>
          </template>
        </div>
        <!-- <div class="go_button textlink">
						<span class="go_register" @click="goregister">{{ $t('login.register') }}</span>
						<span class="go_psw" @click="gopasswords">{{ $t('login.passwords') }}</span>
					</div> -->

        <div class="login_tab_cont">
          <div v-if="!isPhoneLogin" class="login_tab_div textlink" style="display: flex; align-items: flex-start;">
            <div class="login_tab_cont_main">
              <div>
                <el-checkbox
                  v-model="checked"
                  class="login_span login_span_flow"
                >
                  {{ $t("login.account") }}
                </el-checkbox>
              </div>
              <div>
                <el-checkbox
                  v-if="checked"
                  v-model="rememberPwdchecked"
                  class="login_span login_span_flow"
                  style="margin-top: 10px;"
                >
                  {{ $t('login.password') }}
                </el-checkbox>
              </div>
            </div>
            <template v-if="$store.state.isLocalServer == false">
              <span
                class="login_span"
                style="white-space: nowrap"
                @click="gopasswords"
              >{{ $t("login.passwords") }}</span>
            </template>
          </div>
          <div v-if="isPhoneLogin" class="login_tab_div textlink">
            <el-checkbox
              v-model="rememberPhonechecked"
              class="login_span left login_span_flow"
            >
              {{ $t('login.rememberPhone') }}
            </el-checkbox>
          </div>
          <el-button
            class="login_button"
            native-type="submit"
            :loading="isloading"
            @click="
              submitForm(
                isPhoneLogin ? 'ruleForm3' : isLogin ? 'ruleForm' : 'ruleForm2'
              )
            "
          >
            {{ $t("login.login") }}
          </el-button>
          <div v-if="$store.state.isLocalServer == false && !isPhoneLogin" class="login_tab_div textlink">
            <span
              class="login_span left"
              @click="login"
            >{{
              !isLogin ? $t("login.text") : $t("login.text2")
            }}</span>
            <!-- <span class="login_span right" @click="login" :class="isLogin ? '' : 'login_curr'">{{ $t('login.text2') }}</span> -->
            <span
              class="login_span right"
              @click="goregister"
            >{{
              $t("login.register")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isCountryTab"
    >
      <v-formCountry
        :country="ruleFormCountry.countryValue"
        @changeCountryValue="changeCountryValue"
        @handleCountryTab="handleCountryTab"
      />
    </div>
    <div
      v-if="isShowAliFrame"
      class="ali-val-iframe"
    >
      <iframe
        id="ali-val-iframe"
        frameborder="0"
      />
    </div>
  </div>
</template>

<script>
import {
  doLoginByPassword,
  doLoginByVerifyCode,
  doSendLoginVerifyCode,
  doLoginOrRegisterByCode,
  CheckSmsVerifyCodeLogin
} from '@/axios/IGetData'
import { alerterror, alertsuccess,returnmessage } from '@/assets/js/common.js'
import {
  hanleDomainWhenClickLoginBtn
} from '@utils/handleDomain'
import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem
} from '@utils/storage'
import seenImg from '@/assets/img/eye_close_login.png'
import unseenImg from '@/assets/img/eye_open_login.png'
import vSwitchLang from '@/components/common/editionSwitchLanguage.vue'
import vChooseCountry from '@/components/OppleCountryChoose/chooseCountry.vue'
import vFormCountry from './components/formCountry.vue'
// import { GetLanguagePacksList,GetBaseData } from '@/axios/ICommon.js';
import vFooter from '@/components/common/footer.vue'
import { host } from '@/assets/js/api';
import {
  GetDeiveStatusList,
  GetAllDeviceCategoryList
} from '@/axios/IDevice.js'
import { REGION_ALI_LANG, REGION_ALI_TELE } from '@/enums/region';
import OppleAliValiCodeBtn from '@/components/OppleAliValiCodeBtn/index.vue';
import { getErrorMsgByStatusCode } from '@/utils/system';
import CryptoJS from 'crypto-js'

// import { locale } from 'moment'
export default {
  components: {
    vSwitchLang,
    vChooseCountry,
    vFormCountry,
    vFooter,
    OppleAliValiCodeBtn
  },
  data () {
    return {
      // options: [], //语言
      seen1: '', // 查看密码
      seen2: '', // 未使用
      unseenImg, // 看不见
      seenImg, // 看得见密码
      pwdType1: false, // 此时文本框隐藏，显示密码框
      pwdType2: false, // 此时文本框隐藏，显示密码框
      isloading: false, // 是否加载
      issending: false, // 是否提交
      Verification: true, // 验证码按钮显示隐藏
      timer: 60, // 验证码倒计时
      ruleForm: {
        name: '',
        eyetxt1: '',
      }, // 表单数据
      ruleForm2: {
        name: '',
        email: '',
      },
      ruleForm3: {
        name: '',
        email: ''
      },
      ruleFormCountry:{
        countryValue: ''
      },
      // 表单数据
      ru1: {
        name: [
          {
            required: true,
            message: this.$t('login.placeholderemail'),
            trigger: ['blur']
          }
        ],
        eyetxt1: [
          { required: true, message: this.$t('login.pswr'), trigger: ['blur'] }
        ],
      }, // 验证规则
      ru2: {
        name: [
          {
            required: true,
            message: this.$t('login.placeholderemail'),
            trigger: ['blur']
          },
          {
            type: 'email', // 要检验的类型（number，email，date等）
            message: this.$t('login.emailformate'),
            trigger: ['blur']
          }
        ],
        email: [
          { required: true, message: this.$t('login.emailr'), trigger: 'blur' }
        ],

      },
      // 验证规则
      rules3: {
        name: [
          {
            required: true,
            message: this.$t('login.phoneplace'),
            trigger: ['blur']
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t('login.phoneerror'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('login.phoneverify'),
            trigger: 'blur'
          }
        ]
      },
      // value: '', //语言版本下拉框的值
      checked: false, // 记住账号
      rememberPwdchecked: false, // 记住密码
      rememberPhonechecked:false, // 记住手机号
      isLogin: true, // 是否账号登陆 否则验证码登陆
      isPhoneLogin: false, // 是否手机验证码登陆
      isCountryTab: false,
      isShowAliFrame: false
    }
  },
  watch: {
    // 修复手机登录状态下切换语言，
    '$store.state.lang': {
      handler (val, last) {
        if (val != 'zh-cn') {
          this.isPhoneLogin = false
        }
      }
    },
  },
  mounted () {
    this.getAcount();
// console.log('process.env.NODE_ENV', this.$store.state.region);

    this.clickHidenAliFrameProxy = this.clickHidenAliFrame.bind(this);
    document.addEventListener('click', this.clickHidenAliFrameProxy);
  },
  destroyed () {
    document.removeEventListener('click', this.clickHidenAliFrameProxy);
  },
  created () {},
  methods: {
    clickHidenAliFrame(e) {
      if (e.target.className.includes('yanz') || e.target.parentNode.className.includes('yanz')) {
        console.log('this.isShowAliFrame', e.target);
        return;
      }
      
      this.isShowAliFrame = false;
    },

    getAliCodeVal() {
      const phoneRegex = /^1\d{10}$/;
      const tele = this.ruleForm3.name;

      if (
        !phoneRegex.test(tele)
      ) {
        this.$message({
          type: "warning",
          message: this.$t('login.validPhoneNumber')
        });

        return;
      }


      this.isShowAliFrame = true;

      this.$nextTick(() => {
        const iframe = document.getElementById('ali-val-iframe')
        const iframeWindow = iframe.contentWindow;
        const language = REGION_ALI_LANG[getLocalStoragItem('lang')] || 'en';
        iframe.src = 'http://localhost:8080/captcha.html';

        const $host = process.env.NODE_ENV === 'development' ? 'https://iot-dev.opple.com' : host;

        iframe.onload = () => {
          console.log('iframe 加载完毕');
          iframeWindow.captchaUrl = `${$host}/baseservice/User/CaptchaVerify`;
          iframeWindow.captchaInitParam = {
            SceneId: '2n1i1xf6',
            prefix: 'hrt068', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            language,
            region: this.$store.state.region, //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
            ClientId: 'opple_business_light'
          };

          iframeWindow.captchaUrlParams = {
            phoneNumber: tele,
            countryCode: REGION_ALI_TELE[this.$store.state.region],
            verifyCodeType: '0',
            clientType: 3
          };

          // 成功
          iframeWindow.resultCallBack = (res) => {
            console.log('返回~成功啦', res);
            if (res.Result) {
              this.isShowAliFrame = false;
            };
            this.handlerCountdown();

            this.$message({
              message: this.$t('invite.span1'),
              type: 'success'
            });
            
            // alert(res);
            
          };
          
          // 失败
          iframeWindow.failCallBack = (error) => {
            console.log('返回~失败啦', error);
            // let message = '';
            // if (error.StatusCode === 1112) {
            //   message = this.$t('login.tryAgain')
            // }

            // this.$message({
            //   message: this.$t('login.tryAgain'),
            //   type: 'error'
            // });
            console.log('resultCallBack fail', error);
          };

          // iframeWindow.myGlobalFunction = function(msg) {
          //   alert(msg);
          // };
        };
      });

     
    },
    handleCountryTab(e){
      this.isCountryTab = e
    },
    /* 判断缓存内是否有该邮箱 */
    handleBlurName(e) {
      
      const emailRegex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (emailRegex.test(e) || phoneRegex.test(e)) {
        try {
          /* 挂在window上的保存 */
          const value = getLocalStoragItem(e)
          this.ruleFormCountry.countryValue = value
          // 获取存储的密码
          this.ruleFormCountry.countryValue = value
          // 获取并解密存储的密码
          const encryptedPwd = getLocalStorageItem(`pwd_${e}`)
          if(encryptedPwd) {
            this.ruleForm.eyetxt1 = this.decryptPassword(encryptedPwd, e)
          }
          if(value){
            this.changeCountryValue(value)
          }
        } catch (error) {

        }
      } else {
        this.ruleFormCountry.countryValue = ''
      }
    },
    // ... 其他方法
    chooseCountry(formName){
      this.$refs[formName].validate((valid) => {
        if(valid){
          /* 填写了国家 */
          this.isCountryTab = false
        }else{
          return false
        }
      })
    },
    changeCountryValue(e){
      this.ruleFormCountry.countryValue = e
      this.$store.commit('setIsEurope', e)
      this.getDefaultDomaims(e)
    },
    // 获取相应的域名
    getDefaultDomaims(e){
      if(this.$store.state.ipConfig && Object.keys(this.$store.state.ipConfig).length > 0) {   
        const ipInfo = this.$store.state.ipConfig[e] 
        window.defaultDomaims = ipInfo?.Domain?.OPBaseUrl || window.location.origin
        window.VUE_APP_socketHost = ipInfo?.Domain?.SocketBaseUrl || window.VUE_APP_socketHost
      }else{
        //延时一秒在去获取
        setTimeout(() => {
          this.getDefaultDomaims(e)
        }, 1000);
      }
    },
    removeCpwdTip ($event) {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        // console.log('ie')
      } else {
        $event.target.removeAttribute('readonly')
      }
    },
    addReadOnly ($event) {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        // console.log('ie')
      } else {
        $event.target.setAttribute('readonly', true)
      }
    },
    /* 缓存获得记住的账号
     */
    getAcount () {
      if (getLocalStorageItem('account')) {
        this.ruleForm.name = getLocalStorageItem('account')
        this.ruleForm2.name = getLocalStorageItem('account')
        this.checked = true
        this.handleBlurName(this.ruleForm.name)
        // 获取记住密码的状态
        const rememberPwd = getLocalStorageItem('rememberPwd')
        this.rememberPwdchecked = this.rememberPwdchecked = rememberPwd ? JSON.parse(rememberPwd) : false
        // 获取存储的手机号
        if (getLocalStorageItem('phoneNumber')) {
            this.ruleForm3.name = getLocalStorageItem('phoneNumber')
            this.rememberPhonechecked = true
          }
        }
    },
    /* 提交去登陆
     */
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //判断是否选择国家
          if(!this.ruleFormCountry.countryValue && !this.isPhoneLogin){
            this.isCountryTab = true
            return
          }
          this.$store.commit('setIsEurope', this.ruleFormCountry.countryValue)
          if (formName === 'ruleForm') {
            this.LoginByPassword(this.ruleForm.name, this.ruleForm.eyetxt1, formName)
          } else if(formName === 'ruleForm2'){
            this.LoginByVerifyCode(this.ruleForm2.name, this.ruleForm2.email, formName)
          }else if (formName === 'ruleForm3') {
            this.LoginByPhone()
          }
        } else {
          return false
        }
      })
    },
    // 添加生成随机密钥的方法
    generateEncryptKey(userId) {
      // 使用固定的信息组合生成密钥
      const fixedSalt = 'opple' // 固定盐值
      return CryptoJS.MD5(`${userId}_${fixedSalt}`).toString()
    },

    // 修改加密方法
    encryptPassword(password, userId) {
      const key = this.generateEncryptKey(userId)
      return CryptoJS.AES.encrypt(password, key).toString()
    },

    // 修改解密方法
    decryptPassword(encryptedPassword, userId) {
      const key = this.generateEncryptKey(userId)
      const bytes = CryptoJS.AES.decrypt(encryptedPassword, key)
      return bytes.toString(CryptoJS.enc.Utf8)
    },
    /* 2种登陆 接口返回数据处理
     * rs 接口返回数据包
     */
    functionDoLoginAction (rs, para,formName) {
      debugger
      if (Number(rs.StatusCode) === Number(this.$store.state.rightStatusCode)) {
        // 处理记住账号
        if (this.checked) {
          setLocalStorageItem('account', para.UserId)
        } else {
          removeLocalStorageItem('account')
        }
        
        // 处理记住手机号
        if (this.rememberPhonechecked && this.isPhoneLogin) {
          setLocalStorageItem('phoneNumber', this.ruleForm3.name)
        } else if (!this.rememberPhonechecked) {
          removeLocalStorageItem('phoneNumber')
        }
        // 处理记住密码
         // 保存记住密码的状态
        setLocalStorageItem('rememberPwd', JSON.stringify(this.rememberPwdchecked))
        if (this.rememberPwdchecked) {
          if(formName === 'ruleForm') {
            const encryptedPassword = this.encryptPassword(this.ruleForm.eyetxt1, para.UserId)
            setLocalStorageItem(`pwd_${para.UserId}`, encryptedPassword)
          }
        } else {
          removeLocalStorageItem(`pwd_${para.UserId}`)
        }

        if(!this.checked) {
          removeLocalStorageItem(`pwd_${para.UserId}`)
        }
        /* 挂在window上的保存 */
        setLocalStoragItem(`${formName==='ruleForm'?this.ruleForm.name:this.ruleForm2.name}`,this.ruleFormCountry.countryValue)
        /* 将登录的国家更新到个人信息内 */
        // setLocalStoragItem('loginUpdateCountry', '1')
        if(this.$store.state.ipConfigOpen){
          const jumpUrl = hanleDomainWhenClickLoginBtn(formName==='ruleForm'?this.ruleForm:this.ruleForm2,this.ruleFormCountry.countryValue,rs.Result)
          if (jumpUrl && jumpUrl.indexOf(window.location.hostname) < 0) {
            window.location.href = jumpUrl
            return
          }
        }

        // }
        this.initStore()
        if (this.isPhoneLogin) {
          this.$store.dispatch('loginByPhone', rs.Result)
        } else {
          this.$store.dispatch('login', rs.Result)
        }
        
        this.$router.push({ name: 'projectDetails' })
      } else if(rs.StatusCode === 12038 || rs.StatusCode === 12039 || rs.StatusCode ===13007){
          const msg = returnmessage(rs.StatusCode)
          const message = this.msgSplit(msg , rs.Result)
          this.$message({
            dangerouslyUseHTMLString: false,
            message,
            type: 'error'
          });
        }else{
          // alerterror(this, rs.StatusCode)
          const msg = getErrorMsgByStatusCode(rs.StatusCode, rs.Result);

          this.$message({
            message: msg,
            type: 'error',
          });
        }
      this.isloading = false
    },
    /**
     *三级等保返回次数
     * @param {String} msg
     * @param {String || Number} num
    */
    msgSplit(msg, num){
      if(msg){
        return msg.split('#')[0] + num + msg.split('#')[2]
      }
    },
    /* 验证码登陆
     */
    LoginByVerifyCode (n, p, formName) {
      let para = { UserId: n, VerifyCode: p }
      this.isloading = true
      doLoginByVerifyCode(para, this.functionDoLoginAction, formName)
      para = null
    },
    /* 账号密码登陆
     */
    LoginByPassword (n, p, formName) {
      let para = { UserId: n, Password: p }
      this.isloading = true
      doLoginByPassword(para, this.functionDoLoginAction, formName)
      para = null
    },
    // 手机验证码登录
    LoginByPhone () {
      const para = {
        // CountryCode: ,
        PhoneNumber: this.ruleForm3.name,
        VerifyCodeType: 0,
        VerifyCode: this.ruleForm3.email,
        IsAutoRegisterUser: true,
        OSType:'Web'
      }

      this.isloading = true
      //  doLoginOrRegisterByCode(para, this.functionDoLoginAction)

      CheckSmsVerifyCodeLogin(para, this.functionDoLoginAction)
    },

    /* 发送验证码  接口返回数据处理
     * rs 接口返回数据包
     */
    functionSendLoginVerifyCode (rs) {
      this.issending = false
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // 发送成功
        alertsuccess(this, rs.StatusCode)
        this.handlerCountdown()
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 发送验证码
     */
    SendLoginVerifyCode (formName2) {
      debugger
      // 发送邮箱登录验证码
      this.$refs[formName2].validateField('name', (valid) => {
        if (valid === '') {
          //判断是否选择国家
          if(!this.ruleFormCountry.countryValue && !this.isPhoneLogin){
            this.isCountryTab = true
            return
          }
          this.issending = true
          let para = { userId: this[formName2].name }
          doSendLoginVerifyCode(para, this.functionSendLoginVerifyCode)
          para = null
        } else {
          return false
        }
      })
    },
    /* 验证码倒计时
     */
     handlerCountdown () {
      this.Verification = false // 点击button改变v-show的状态
      const authTimer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer-- // 递减时间
        if (this.timer <= 0) {
          this.Verification = true // 60s时间结束还原v-show状态并清除定时器
          clearInterval(authTimer)
          this.timer = 60
        }
      }, 1000)
    },
    /* 切换登陆方式
     */
    login () {
      if (this.$store.state.isLocalServer == false) {
        !this.isPhoneLogin?this.isLogin = !this.isLogin:this.isLogin = this.isLogin
      }
      this.isPhoneLogin = false
      /* 还原api配置项 */
      // this.$store.state.ipConfigOpen = window.ipConfigOpen || false
      this.$store.state.ipConfigOpen = process.env.VUE_APP_ipConfigOpen === 'true' || false
    },
    /**
     * 点击手机登陆
     */
    login_phone () {
      this.isPhoneLogin = true
      /* iPhone关闭域名切换功能 */
      this.$store.state.ipConfigOpen = false
    },
    /* 密码1眼睛的变化
     */
    changeType1 () {
      this.seen1 = !this.seen1 // 小眼睛的变化
      this.pwdType1 = !this.pwdType1 // 跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    /* 密码2眼睛的变化
     */
    changeType () {
      this.seen = !this.seen // 小眼睛的变化
      this.pwdType = !this.pwdType // 跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    /* 去注册
     */
    goregister () {
      this.$router.push({ name: 'regist' })
    },
    /* 设置密码
     */
    gopasswords () {
      this.$router.push({ name: 'setPsw' })
    },
    /* 清空缓存
     */
    initStore () {
      // 清空缓存
      removeLocalStorageItem('userinfor')
      removeLocalStorageItem('ucloundid')
      removeLocalStorageItem('token')
      removeLocalStorageItem('projectcode')
      this.$store.dispatch('login', {})
      this.$store.dispatch('changeProjectcode', '')
      this.$store.dispatch('changeUserinfor', {})
    }
  }
}
</script>

<style lang="scss" scoped>
/* 登陆主页 */
@import '../../assets/css/color';
.hidden{
  opacity: 0;
}

.login_reginster {
  background-image: url('../../assets/img/login/login_bg.png');
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  .login_info {
    position: absolute;
    bottom: 70px;
    left: 80px;
    color: #ffffff;
    .login_text1 {
      margin-bottom: 10px;
      font-size: 14px;
    }
    .login_text2 {
      font-size: 20px;
    }
  }
  .login_cont {
    position: absolute;
    width: 360px;
    height: 480px;
    border-radius: 4px;
    background: linear-gradient(
      207deg,
      rgb(82 124 204 / 80%),
      rgb(177 200 246 / 50%)
    );
    box-shadow: 1px 40px 59px 0 rgb(40 74 151 / 43%);
    .login_logo {
      display: block;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 40px;
    }
    .login_tab {
      margin: 0 40px;
      .login_tab_div {
        overflow: hidden;
        margin: 0 45px;
        margin-bottom: 15px;
        height: auto;
        display: flex;
        justify-content: space-between;
        .login_span {
          display: inline-block;
          height: 22px;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
        }
        .login_span_flow {
          overflow: hidden;
          white-space: nowrap;
          flex: 1;
        }
        .right {
          float: right;
          text-align: right;
        }
        .left {
          float: left;
        }
        .login_curr {
          color: #ffffff !important;
        }
        .title {
          font-size: 18px !important;
          color: $color22;
        }
        .line {
          text-align: center;
          color: $color22;
        }
      }
      .top {
        padding-bottom: 28px;
      }
      .login_tab_cont {
        .login_button {
          margin-top: 40px;
          margin-bottom: 20px;
          width: 100%;
          height: 48px;
          font-size: 16px;
          border-radius: 3px;
          color: #fefefe;
          background: rgb(0 70 170 / 100%);
        }
        .login_line {
          position: relative;
          width: 100%;
          border-bottom: 1px solid $line;
          color: $color3;
          input {
            position: absolute;
            left: 45px;
            width: 60%;
            height: 100%;
            border: none;
            outline: none;
          }
          .eye {
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -5px;
          }
          .yanz {
            position: absolute;
            top: 0;
            right: 0;
            padding: 20px 15px;
          }
        }
        .agreen {
          margin-bottom: 20px;
          width: 100%;
        }
      }
      .go_button {
        display: flex;
        margin-top: 40px;
        font-size: 14px;
        text-align: center;
        color: $color2;
        .go_register {
          float: left;
          width: 50%;
          border-right: 1px solid #bed7f3;
          flex: 1;
        }
        .go_psw {
          float: left;
          width: 50%;
          flex: 1;
        }
      }
    }
  }
}

</style>
<style lang="scss">
.opple-country{
    position: absolute;
    right: 100px;
    top: 12px;
    font-size: 13px;
    color: #434343;
    cursor: pointer;
    width: 125px;
    .el-input--small .el-input__inner{
      color: #fff  !important;
      background: transparent !important;
      border: none;
      overflow: hidden !important;          /* 隐藏超出容器的内容 */
      white-space: nowrap !important;       /* 强制文本在一行显示 */
      text-overflow: ellipsis !important;   /* 超出部分显示省略号 */
    }
    .el-input__prefix{
      top: 4px;
    }
}
.footer-icp{
    position: absolute !important;
    left: 0 !important;
    padding-right:140px;
  .footer-copyright{
    justify-content:flex-end !important;
    color: #fff !important;
    a{
      color: #fff !important;
    }
  }
}
.login_tele {
  .el-form-item__content {
    display: flex;

    .login_ali-vali-codeBtn {
      display: flex;
      white-space: nowrap;
      align-items: center;
      justify-content: center;
      padding: 4px 6px 0 0;
    }
  }
}
</style>
